module.exports = __webpack_public_path__ + "static/social_twitter-7f1c674604ba8093569b78a8aaa9ac3c.png";